module.exports = __webpack_public_path__ + "static/media/B3.7cb257c7.jpg";